import {NetworkAPIVersion, NetworkParamType} from './network.utils';

export default {
  searchPlaces: {
    url: 'place/search/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
    autoCancel: true,
    params: {
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],
      q: [NetworkParamType.string],

      clan: [NetworkParamType.string],
      clan_name: [NetworkParamType.string],
      level: [NetworkParamType.string],
      root: [NetworkParamType.array],
      is_qiao_xiang: [NetworkParamType.string],
      migration_place_id: [NetworkParamType.string],
      fields: [NetworkParamType.string],
      is_ancestral_place: [NetworkParamType.string],
    },
  },
  searchPlaceAlternatives: {
    url: 'place/search-alternatives/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
    autoCancel: true,
    params: {
      q: [NetworkParamType.string],
      ancestral_places: [NetworkParamType.boolean],
      historical_places: [NetworkParamType.boolean],
    },
  },
  getCommonPlaceAlternatives: {
    url: 'place/common/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
  },
  getCreatePlaceOptions: {
    url: 'place/create/options/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
  },
  createPlace: {
    url: 'place/create/',
    method: 'post',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      name: [NetworkParamType.string],
      pinyin: [NetworkParamType.string],
      level: [NetworkParamType.number],
      level_name: [NetworkParamType.string],
      parent_id: [NetworkParamType.number],
      is_ancestral_place: [NetworkParamType.boolean],
      major_clans: [NetworkParamType.array],
      dialects: [NetworkParamType.array],
    },
  },
  getPlacesDetail: {
    url: 'place/{id}/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'get',
    restful: true,
    params: {
      ID: [NetworkParamType.string],
      fields: [NetworkParamType.string],
    },
  },
  saveLocation: {
    url: 'place/{id}/save-location/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'post',
    params: {
      location: [NetworkParamType.object],
    },
  },
  migrationRegions: {
    url: 'place/migration-regions/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'get',
  },
};
